import axios from "axios";
class SHRequest {
  instance;
  constructor(config) {
    this.instance = axios.create(config);
    this.instance.interceptors.request.use(
      (config) => {
        const session = JSON.parse(
          localStorage.getItem("sb-zevgwqoenxkhkvornmdw-auth-token")
        );
        if (config.headers) {
          config.headers.Authorization = `Bearer ${session.access_token}`;
        }
        return config;
      },
      (error) => {
        return error;
      }
    );
    this.instance.interceptors.response.use(
      (res) => {
        return res;
      },
      (error) => {
        return error;
      }
    );
  }
  request(config) {
    return new Promise((resolve, reject) => {
      this.instance
        .request(config)
        .then((res) => {
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }
  get(config) {
    return this.instance.request({ ...config, method: "GET" });
  }
  post(config) {
    return this.instance.request({ ...config, method: "POST" });
  }
  put(config) {
    return this.instance.request({ ...config, method: "PUT" });
  }
  delete(config) {
    return this.instance.request({ ...config, method: "DELETE" });
  }
}
export default SHRequest;
